export const PORTAL_PERMISSIONS = {
	createOrders: 'portal.createOrders',
	manageClients: 'portal.manageClients',
} as const;

export type TPortalPermission =
	typeof PORTAL_PERMISSIONS[keyof typeof PORTAL_PERMISSIONS];
